import React from 'react';
import { renderToString } from 'react-dom/server';
import Avatar from '~/components/shared/Avatar';

export default class AutoCompleteUI {
  constructor(editor, aCInstance) {
    this.editor = editor;
    this.queryBy = aCInstance.options.queryBy;
  }

  renderInput = () => {
    const rawHtml = `
      <span id="mentions-autocomplete">
        <span id="autocomplete-delimiter">@</span>
        <span id="autocomplete-searchtext">
          <span class="dummy">\u200b</span>
        </span>
      </span>`;

    this.editor.execCommand('mceInsertContent', false, rawHtml);
    this.editor.focus();
    this.selectFirstDummySpan();
  };

  selectFirstDummySpan = () => {
    const dummySpan = this.editor.selection.dom.select('span#autocomplete-searchtext span')[0];
    this.editor.selection.select(dummySpan);
    this.editor.selection.collapse(0);
  };

  renderDropdown = () => {
    const dropdown = document.createElement('ul');
    dropdown.className = 'rte-autocomplete dropdown-menu';

    const listItem = document.createElement('li');
    listItem.className = 'loading text-center';

    const spinnerIcon = document.createElement('i');
    spinnerIcon.className = 'far fa-spinner';

    listItem.appendChild(spinnerIcon);
    dropdown.appendChild(listItem);

    return dropdown;
  }

  renderItem = (item) => {
    const name = item[this.queryBy];
    const avatarHtml = renderToString(
      <Avatar
        name={name}
        avatar={item.avatar}
        sizeType="small"
        showTooltip={false}
        extraClasses="mx-2"
      />,
    );

    const html = `
      <li ${Object.entries(item).map(([key, value]) => `data-${key}="${value}"`).join(' ')}>
        <button type="button" class="mention-item">
          ${avatarHtml}
          <span class="suggestion-text">${name}</span>
        </button>
      </li>`;
    return html;
  }
}
